import React from 'react';

const LodgeForm = ({ formData, handleInputChange, errors }) => {
  return (
    <>
      <div className="form-group">
        <label>
          Type of bathroom
        </label>
        <select
          type="text"
          name="type_of_bathroom"
          value={formData.type_of_bathroom}
          onChange={handleInputChange}
          required
          className="fancy-input"
        >
          <option value="">Select type of bathroom</option>
          <option value="shared">Shared</option>
          <option value="private">Private</option>
        </select>
        {errors.type_of_bathroom && <div className="error-text">{errors.type_of_bathroom}</div>}
      </div>

      <div className="checkboxes">
        

        <div className="form-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="has_parking_space"
              checked={formData.has_parking_space}
              onChange={handleInputChange}
            />
            Has Parking Space
          </label>
        </div>

        <div className="form-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="has_outdoor_space"
              checked={formData.has_outdoor_space}
              onChange={handleInputChange}
            />
            Outdoor Space
          </label>
        </div>
      </div>

      <div className="checkboxes">
        <div className="form-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="has_wifi"
              checked={formData.has_wifi}
              onChange={handleInputChange}
            />
            WiFi Available
          </label>
        </div>

        <div className="form-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="has_tv"
              checked={formData.has_tv}
              onChange={handleInputChange}
            />
            TV Available
          </label>
        </div>
      </div>

      <div className="checkboxes">
        <div className="form-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="has_air_conditioning"
              checked={formData.has_air_conditioning}
              onChange={handleInputChange}
            />
            Air Conditioning
          </label>
        </div>

        <div className="form-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="has_restaurant"
              checked={formData.has_restaurant}
              onChange={handleInputChange}
            />
            Restaurant
          </label>
        </div>
      </div>

      <div className="checkboxes">
        <div className="form-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="has_bar"
              checked={formData.has_bar}
              onChange={handleInputChange}
            />
            Bar
          </label>
        </div>

        <div className="form-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="has_security"
              checked={formData.has_security}
              onChange={handleInputChange}
            />
            Security
          </label>
        </div>
      </div>

      
    </>
  );
};

export default LodgeForm;
